module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "banxin foot-min clearfix"
  }, [_c('dl', [_c('dt', [_vm._v("关于我们")]), _vm._v(" "), _c('dd', {
    staticClass: "can-click",
    on: {
      "click": _vm.goAbout
    }
  }, [_vm._v("益程简介")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("益程青年公益")]), _vm._v(" "), _c('dd', {
    staticClass: "can-click",
    on: {
      "click": function($event) {
        _vm.goService(1)
      }
    }
  }, [_vm._v("参与项目")]), _vm._v(" "), _c('dd', {
    staticClass: "can-click",
    on: {
      "click": function($event) {
        _vm.goService(2)
      }
    }
  }, [_vm._v("参与分享")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": _vm.erweima,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banxin",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.openBA
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "bei"
  }, [_vm._v("\n      Copyright © 2016 www.yc-charity.com All Rights Reserved. 益程青年公益\n      版权所有\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "dl-last"
  }, [_c('dt', [_vm._v("联系我们")]), _vm._v(" "), _c('dd', [_vm._v("联系电话：19542765868")]), _vm._v(" "), _c('dd', [_vm._v("邮箱：info@yc-charity.com")]), _vm._v(" "), _c('dd', [_vm._v("地址：上海市浦东新区上南路 3855 号 7 号楼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bei bei-t"
  }, [_c('span', {
    staticClass: "icon icon-bei"
  }), _vm._v(" 沪CP备19002960号\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c90391f6","hasScoped":true}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 484
// module chunks = 0 1 2 3 4 5 6 7 8